import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import CaseCallLogModel from "../../models/case-call-log";

export default class CaseCallLogRepository extends BaseRepository {
  static modelClass = CaseCallLogModel;
  modelName = "case-call-log";
}
